import { useState } from "react";
import { useDropzone } from "react-dropzone";
import NavBarHome from "../NavBarHome";
import RecentViews from "../recents/RecentView";
import { Loader } from "../Loader/Loader";
import "./Home.css";

function MyViews() {
  const [isLoading, setIsLoading] = useState(true);
  const { getRootProps, getInputProps } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles) => {
      console.log("Dropzone file accepted: ", acceptedFiles);
      // Handle file processing here
    },
    accept: {
      "application/pdf": [],
      "text/csv": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "application/json": [],
    },
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <NavBarHome title="Views" />
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="cardPage">
        <br />
        {/* <div className="pageHeader">
          <div className="headerLabel0">FILE NAME</div>
          <div className="headerLabel">OWNER</div>
          <div className="headerLabel" style={{ width: "24px;" }}>
            .{" "}
          </div>
        </div> */}
        <RecentViews isMenu={false} showActions={true} isLoading={isLoading} setIsLoading={setIsLoading} />
      </div>
    </div>
  );
}

export default MyViews;
